module.exports = __webpack_public_path__ + "static/media/venice_sunset_1k.704548cc.hdr";